// swiperを設定
const relevanceItemsSwiper = new Swiper('.productDetail__info__swiper', {
  slidesPerView: 3,
  spaceBetween: 5,
  initialSlide: 0,
  breakpoints: {
    // スライドの表示枚数：1024px以上の場合
    1024: {
      slidesPerView: 4,
    },
  },
  navigation: {
    nextEl: '.productDetail__info__swiper-button-next',
    prevEl: '.productDetail__info__swiper-button-prev',
  },
});

// vendorを変換
const brandMap = {
  1111: 'SANYOCOAT',
  1131: 'THE SCOTCH HOUSE',
  1142: 'Paul Stuart',
  1145: 'Paul Stuart',
  1148: '三陽山長',
  1154: 'EPOCA UOMO',
  1158: 'MACKINTOSH PHILOSOPHY',
  1311: 'MACKINTOSH LONDON',
  1411: 'BLACK LABEL CRESTBRIDGE',
  2111: 'SANYOCOAT',
  2151: 'Paul Stuart',
  2155: 'Paul Stuart',
  2211: 'TRANS WORK',
  2212: 'TRANS WORK',
  2213: 'EVEX by KRIZIA',
  2214: 'EVEX by KRIZIA',
  2231: 'AMACA',
  2301: 'MACKINTOSH PHILOSOPHY',
  2321: 'EPOCA',
  2341: 'CAST:',
  2361: 'TO BE CHIC',
  2362: 'TO BE CHIC',
  2511: 'MACKINTOSH LONDON',
  2512: 'MACKINTOSH LONDON',
  2611: 'BLUE LABEL CRESTBRIDGE',
  2121: 'S.ESSENTIALS',
  2352: 'LOVELESS',
  3111: 'CB CRESTBRIDGE',
  3151: 'CB CRESTBRIDGE',
  3551: 'STORY AND THE STUDY',
  3651: 'ECOALF',
};

window.addEventListener('DOMContentLoaded', async () => {
  const loader = document.querySelectorAll('[data-loader-key="relevanceItems"]');
  // 関連商品を取得
  try {
    const relevanceItems = await getRelevanceItems();
    if (!relevanceItems) return;
    // 関連商品を表示順にソート
    relevanceItems.sort((a, b) => a.order - b.order);
    // Swiperにスライドを追加
    relevanceItemsSwiper.forEach(swiper => {
      swiper.appendSlide(
        relevanceItems.map(item => {
          let discountRate = 0;
          if (
            item.variants.edges[0].node.compareAtPrice &&
            item.variants.edges[0].node.price.amount < item.variants.edges[0].node.compareAtPrice
          ) {
            discountRate = Math.round(
              (1 -
                item.variants.edges[0].node.price.amount /
                  item.variants.edges[0].node.compareAtPrice) *
                100
            );
          }
          return `
            <li class="swiper-slide productDetail__info__recommend__slide">
            <a class="productDetail__info__recommend__link" href="/products/${item.handle}">
              <img
                src="${item.images.edges[0].node.originalSrc}"
                alt=""
                class="productDetail__info__recommend__img"
              >
              <p class="productDetail__info__recommend__vendor">${brandMap[item.vendor]}</p>
              <p class="productDetail__info__recommend__text">${item.title}</p>
              <p class="productDetail__info__recommend__priceBox ${
                discountRate !== 0 ? 'isDiscount' : ''
              }"><span class="productDetail__info__recommend__price">¥${Number(
            item.variants.edges[0].node.price.amount
          ).toLocaleString()}</span><span class="productDetail__info__recommend__tax">税込</span><span class="productDetail__info__recommend__discount">${
            discountRate !== 0 ? `${discountRate}%OFF` : ''
          }</span></p>
            </a>
          </li>
            `;
        })
      );
      // ローディングを非表示にし、Swiperを表示する
      loader.forEach(loader => loader.classList.add('hidden'));
      const swiperContainer = document.querySelectorAll('.productDetail__info__swiper');
      swiperContainer.forEach(swiper => swiper.classList.remove('hidden'));

      // 読み込みが完了したら矢印を表示
      const swiperNextBtn = document.querySelectorAll('.productDetail__info__swiper-button-prev');
      const swiperPrevBtn = document.querySelectorAll('.productDetail__info__swiper-button-next');
      swiperNextBtn.forEach(btn => btn.classList.remove('hidden'));
      swiperPrevBtn.forEach(btn => btn.classList.remove('hidden'));
    });
  } catch (error) {
    console.error(error);
  }
});

// 商品ID配列を受け取り、ShopifyのStoreFrontAPIから商品詳細を取得し、商品配列にして返す
const getRelevanceItems = async () => {
  if (!document.getElementById('relevanceItems')) return;
  const relevanceProducts = JSON.parse(document.getElementById('relevanceItems').innerText || '[]');
  const relevanceItems = [];
  for await (const product of relevanceProducts) {
    const id = product?.productId ?? product.product_id;
    const order = product?.productOrder ?? product.product_order;
    const data = await fetch(`${SHOPIFY_STOREFRONT_API_URL}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': document.querySelector('#storeFrontAccessToken').value,
      },
      body: JSON.stringify({
        query: `{
          node(id: "${id}") {
            ... on Product {
              title
              handle
              vendor
              images(first: 1) {
                edges {
                  node {
                    originalSrc
                  }
                }
              }
              variants(first: 1) {
                edges {
                  node {
                    price {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
          }
        }`,
      }),
    })
      .then(res => {
        if (!res.ok) {
          throw new Error();
        }
        return res.json();
      })
      .then(res => {
        return res.data.node;
      });
    // 商品配列に商品詳細を追加
    relevanceItems.push({
      ...data,
      order,
    });
  }
  return relevanceItems;
};
